<form
  [formGroup]="shiftModelsFormGroup"
  autocomplete="off"
  class="mat-dialog-add-shift-model-container"
>
  <div class="detail-card-header mat-dialog-add-content">
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{
          (isEditMode
            ? "shift.label.updateShiftModel"
            : "shift.button.addShiftModels"
          ) | translate
        }}
      </div>
    </span>
  </div>
  <mat-divider class="wh-dialog-divider"></mat-divider>
  <div class="mat-dialog-add-content">
    <div>
      <ng-container formArrayName="shiftModels">
        <ng-container
          *ngFor="let shiftModel of shiftModels.controls; let i = index"
          class="shift-models-container"
        >
          <app-shift-model-fields
            [shiftModelsFormGroup]="getModelByIndex(i)"
            [canDelete]="!isEditMode"
            (onDelete)="deleteShiftModel(i)"
          ></app-shift-model-fields>
        </ng-container>
        <div *ngIf="shiftModels.controls.length === 0">
          {{ "shift.label.noShiftModels" | translate }}
        </div>
        @if (!isEditMode) {
          <div class="flex--r-c-r flex-1 p-t--16 p-b--16">
            <w-h-button
              [text]="'shift.button.addShiftModel' | translate"
              matIcon="add"
              color="accent"
              type="flat"
              (clicked)="addShiftModel()"
            />
          </div>
        }

        @if (shiftModels.errors) {
          <div>{{ "error.formValidation.title" | translate }}</div>
          <div class="messages-container warn m--8">
            <!-- Duration error -->
            @if (shiftModels.errors?.shiftDurationTooShort; as error) {
              <mat-error>
                {{
                  "shift.error.shiftDurationTooShort"
                    | translate
                      : {
                          minDuration: error?.minDurationMinutes,
                          actualDuration: error?.actualDurationMinutes,
                          startTime: error?.startTime,
                          endTime: error?.endTime,
                        }
                }}
              </mat-error>
            }

            <!-- Overlap error -->
            @if (shiftModels.errors?.shiftsOverlap; as error) {
              <mat-error>
                {{
                  "shift.error.shiftsOverlap"
                    | translate
                      : {
                          shift1:
                            error.shift1Name ??
                            ("shift.label.shiftWithIndex"
                              | translate: { index: error.shift1Index + 1 }),
                          shift2:
                            error.shift2Name ??
                            ("shift.label.shiftWithIndex"
                              | translate: { index: error.shift2Index + 1 }),
                        }
                }}
              </mat-error>
            }

            @if (shiftModels.errors?.duplicateName; as error) {
              <mat-error>
                {{
                  "shift.error.duplicateShiftNames"
                    | translate
                      : {
                          names: error.duplicateNames.join(", "),
                        }
                }}
              </mat-error>
            }
          </div>
        }
      </ng-container>
    </div>
    <w-h-button-group align="end" mat-dialog-actions>
      <w-h-button
        [text]="'app.cancel.label' | translate | uppercase"
        matIcon="close"
        type="stroked"
        (clicked)="cancel()"
      />

      <w-h-button
        [text]="'app.confirm.label' | translate | uppercase"
        matIcon="save"
        [isLoading]="!!(loading$ | async)"
        color="accent"
        type="flat"
        [disabled]="this.shiftModelsFormGroup.invalid"
        (clicked)="confirm()"
      />
    </w-h-button-group>
  </div>
</form>
